import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import Layout from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import HowItWorks from "@/pages/HowItWorks";
import Calendar from "@/pages/Calendar";
import Leaderboard from "@/pages/Leaderboard";
import Prizes from "@/pages/Prizes";
import Subscription from "@/pages/Subscription";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import { Login, Register, ForgotPassword, ResetPassword, VerifyEmail } from "@/pages/Auth";
import { FAQ, Contact, Terms, Privacy, Cookie, Rules } from "@/pages/StaticPages";
import NotFound from "@/pages/NotFound";

function Shell({ children }) {
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Toaster position="top-center" theme="dark" richColors />
        <Routes>
          {/* Standalone (no layout) */}
          <Route path="/login" element={<Login />} />
          <Route path="/registrati" element={<Register />} />
          <Route path="/recupera-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verifica-email" element={<VerifyEmail />} />

          {/* With layout */}
          <Route path="/" element={<Shell><Home /></Shell>} />
          <Route path="/come-funziona" element={<Shell><HowItWorks /></Shell>} />
          <Route path="/calendario" element={<Shell><Calendar /></Shell>} />
          <Route path="/classifica" element={<Shell><Leaderboard /></Shell>} />
          <Route path="/premi" element={<Shell><Prizes /></Shell>} />
          <Route path="/abbonamento" element={<Shell><Subscription /></Shell>} />
          <Route path="/faq" element={<Shell><FAQ /></Shell>} />
          <Route path="/contatti" element={<Shell><Contact /></Shell>} />
          <Route path="/termini" element={<Shell><Terms /></Shell>} />
          <Route path="/privacy" element={<Shell><Privacy /></Shell>} />
          <Route path="/cookie-policy" element={<Shell><Cookie /></Shell>} />
          <Route path="/regolamento" element={<Shell><Rules /></Shell>} />

          <Route path="/profilo" element={<ProtectedRoute><Shell><Profile /></Shell></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute adminOnly><Shell><Admin /></Shell></ProtectedRoute>} />

          <Route path="*" element={<Shell><NotFound /></Shell>} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
